import viewStatementTemplate from './ViewStatement.template.html';

/*******************************************************************************
 * Component: ViewStatement */
/**
 * @ngdoc   component
 * @module  bankReconHistory
 * @name    bankReconHistory.component:viewStatement
 * @description
 * Displays the summary information (containing the debit/credit sums for cleared
 * and unlceared), as well as the line item breakdowns for debits and credits.
 * Implements the {@link books.ui.bankRecon.component:reconSummary reconSummary}
 * and {@link books.ui.bankRecon.component:reconItems reconItems} components.
 *******************************************************************************/
export const viewStatementComponent = {
  template: viewStatementTemplate,
  bindings: { routePackage: '<' },
  controller: ViewStatementController
}

/*******************************************************************************
 * Controller: ViewStatementController */
/**
 * @ngdoc     controller
 * @module    bankReconHistory
 * @name      bankReconHistory.controller:ViewStatementController
 * @requires  books.ui.bankRecon.service:BooksData
 * @description
 * Controller for the {@link bankReconHistory.component:viewStatement viewStatement}
 * component.
 *******************************************************************************/
/* @ngInject */ function ViewStatementController(
  $location,
  $routeParams,
  Alert,
  BooksData,
  BankReconService,
  BusyScreen,
  PrintStatementDialog,
  SERVER,
  uiGridConstants
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Controller Instance Reference. */ var mThis = this;
  /** Print dialog is open. */ var mPrintDialogOpen = false;

  /** Credits grid Type column filter. */
  var mCheckTypeFilter = {
    term: null,
    type: uiGridConstants.filter.SELECT,
    condition: uiGridConstants.filter.EXACT
  };
  /** Debits grid Type column filter. */
  var mDepositTypeFilter = {
    term: null,
    type: uiGridConstants.filter.SELECT,
    condition: uiGridConstants.filter.EXACT
  };

  /** Get label names from server. */
  mThis.checksLabel = SERVER.BooksWebConstants.checksLabel;
  mThis.depositsLabel = SERVER.BooksWebConstants.depositsLabel;

  /*-----------*/
  /* App Flags */
  /*-----------*/
  /** Restrict statement removal. */
  mThis.preventRemove = !!SERVER.appFlags.restrictReconRemove;

  /*****************************************************************************
   * $onInit */
  /**
   * @ngdoc     method
   * @module    bankRecon
   * @methodOf  bankRecon.controller.ViewStatementController
   * @name      $onInit
   * @description
   * Initializes the application with the requested bank statement.
   *****************************************************************************/
  mThis.$onInit = function () {
    var typeSelectOptions = [];

    /*------------------------------*/
    /* Set the statement and items. */
    /*------------------------------*/
    mThis.statement = new BooksData.BankStatement(
      mThis.routePackage.statement,
      mThis.routePackage.items
    );
    var items = mThis.routePackage.items;

    /*---------------------------------------*/
    /* We only want to see the cleared items */
    /* if the statement has been reconciled. */
    /*---------------------------------------*/
    if (mThis.statement.reconciled)
      items = items.filter(function (item) {
        return item.cleared;
      });

    mThis.statementItems = items;
    BusyScreen.setBusy(false);
  };

  /*****************************************************************************
   * printStatement */
  /**
   * @ngdoc     method
   * @module    bankReconHistory
   * @methodof  bankReconHistory.controller:StatementListController
   * @name      printStatement
   * @description
   * Opens the print dialog for selecting report type and whether to include
   * detail.
   *****************************************************************************/
  mThis.printStatement = function () {
    if (!mThis.statement || mPrintDialogOpen) return;

    mPrintDialogOpen = true;
    PrintStatementDialog.show(mThis.statement.id).finally(function () {
      mPrintDialogOpen = false;
    });
  };

  /*****************************************************************************
   * removeStatement */
  /**
   * @ngdoc     method
   * @module    bankReconHistory
   * @methodof  bankReconHistory.controller:StatementListController
   * @name      removeStatement
   * @description
   * Drops the selected bank statement.
   *****************************************************************************/
  mThis.removeStatement = function () {
    /*------------------------*/
    /* Check for a selection. */
    /*------------------------*/
    if (!mThis.statement) {
      Alert.info('A selection is needed for the remove.', 'No Selection');
      return;
    }

    /*----------------------*/
    /* Confirm the removal. */
    /*----------------------*/
    Alert.confirm(
      'Are you sure you want to undo this bank reconciliation?',
      'Removal Confirm'
    ).then(function (resp) {
      BusyScreen.promise(
        BankReconService.dropStatement(mThis.statement.id).then(
          mThis.returnToMain,
          function (err) {
            Alert.error(
              err.parsedResponse.message() ||
                'Error removing the bank reconciliation',
              'Failed to remove statement'
            );
          }
        )
      );
    });
  };

  /*****************************************************************************
   * returnToMain */
  /**
   * @ngdoc     method
   * @module    bankReconHistory
   * @methodof  bankReconHistory.controller:StatementListController
   * @name      returnToMain
   * @description
   * Returns to the main route.
   *****************************************************************************/
  mThis.returnToMain = function () {
    $location.path('/');
  };
}
